import { Spacer, HStack, Stack } from '@chakra-ui/react'
import type { FC } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Button } from '@app/components/ui/button'
import { DialogBackdrop, DialogContent, DialogRoot, DialogTitle } from '@app/components/ui/dialog'
import useGetObjectsByProperties from '@app/hooks/useGetObjectsByProperties'
import ClearContextButton from '@app/pages/maps/components/clearContextButton'
import BusinessContext from '@app/pages/settings/organization/components/businessContext'
import Can from '@app/shared/authorization/can'
import { useBusinessContextQuery } from '@graphql/queries'

const EditContext: FC = () => {
  const navigate = useNavigate()
  const { businessContextId } = useParams()

  useBusinessContextQuery({
    variables: { id: businessContextId }
  })

  const filters = businessContextId ? { slug: businessContextId } : { parentBusinessContextSlug: null }

  const businessContexts = useGetObjectsByProperties('businessContext', filters)
  const businessContext = businessContexts?.[0]

  if (!businessContext) {
    return null
  }

  const handleClose = () => {
    navigate('..')
  }

  return (
    <DialogRoot open placement="center" onOpenChange={() => handleClose()} size="xl">
      <DialogBackdrop />
      <DialogContent>
        <Stack p={4} gap={4}>
          <HStack>
            <DialogTitle>{businessContext.name}</DialogTitle>
            <Spacer />
            <Can I="delete" a="businessContext">
              <ClearContextButton businessContext={businessContext} onClear={handleClose} />
            </Can>
          </HStack>
          <BusinessContext businessContextId={businessContext.id} />
          <HStack>
            <Spacer />
            <Button variant="surface" onClick={handleClose}>
              Done
            </Button>
          </HStack>
        </Stack>
      </DialogContent>
    </DialogRoot>
  )
}

export default EditContext
